<template>
  <c-trend-chart v-if="!params.node.group" :values="values">
    <template slot="ariaTitle">
      <span class="sr-only" v-if="accessibilityFeatures"
        >{{ getAriaText(params) }}{{ $t('white-label.components.quoteTrend.quoteTrendGraphic') }}</span
      >
    </template></c-trend-chart
  >
</template>

<script>
import CTrendChart from '@custom/CTrendChart';
import { getAriaText } from '@utils/helpers';

export default {
  name: 'quote-ticker-renderer',
  components: {
    CTrendChart
  },
  data() {
    return {
      values: []
    };
  },
  methods: {
    getAriaText,
    parseTicks(ticks) {
      let i = ticks.length - 1;
      this.values = [];
      while (i > 0 && this.values.length < 10) {
        const prevTick = ticks[i - 1];
        const tick = ticks[i];
        let val = 0;
        if (tick.bid > prevTick.bid && tick.ask > prevTick.ask) val = 1;
        else if (tick.bid > prevTick.bid || tick.ask > prevTick.ask) val = 0.5;
        else if (tick.bid < prevTick.bid && tick.ask < prevTick.ask) val = -1;
        else if (tick.bid < prevTick.bid || tick.ask < prevTick.ask) val = -0.5;
        if (val) this.values.unshift(val);
        else ticks.splice(i, 1);
        i--;
      }
      // remove unneeded ticks from data row
      if (i > 0) ticks.splice(0, i);
    },
    refresh(params) {
      this.params = params;
      if (!this.params.value) return false;
      this.parseTicks(params.value);
      return true;
    }
  },
  mounted() {
    if (this.params.value) this.parseTicks(this.params.value);
  },
  computed: {
    accessibilityFeatures() {
      return this.$store.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    }
  }
};
</script>
